<template>
  <div class="container">
    <div class="row">
      <div class="col-md-3 col-lg-2 col-xl-2 navbar-collapse sidebar">
        <div class="head-page">
          <div class="page-title">
            <div class="title">
              <h1>
                Storage
                <a href="https://vikingo.org/engine/docs/storage" title="Documentation" target="_blank"><sup><img
                      src="@/assets/icon/info.svg" width="12" /></sup></a>
              </h1>
            </div>
          </div>
        </div>

        <div class="pill-control">
          <ul class="nav nav-pills unit-group" id="pills-tab" role="tablist">
            <li class="nav-item" role="presentation">
              <router-link role="tab" :to="{ name: 'StorageFiles' }" class="nav-link"
                v-bind:class="{ active: view != 'kv' && view != 'tables' }">Files</router-link>
            </li>
            <li class="nav-item" role="presentation">
              <router-link role="tab" :to="{ name: 'StorageKV' }" class="nav-link"
                v-bind:class="{ active: view == 'kv' }">K/V</router-link>
            </li>
            <!-- 
            <li class="nav-item" role="presentation">
              <router-link
                role="tab"
                :to="{ name: 'StorageTables' }"
                class="nav-link"
                v-bind:class="{ active: view == 'tables' }"
                >Tables</router-link
              >
            </li>
            -->
          </ul>
        </div>
        <div class="category-list">
          <el-button :loading="false" class="btn btn-primary btn-lg" @click="createNewFile" icon="vik vik-plus">
            New file
          </el-button>
          <el-button style="margin-top:5px" :loading="false" class="btn btn-primary btn-lg" @click="uploadFile"
            icon="el-icon-upload">
            Upload file
          </el-button>
          <h2 style="margin-top: 13px;" v-if="view == 'files'">Filter</h2>
          <el-form v-if="view == 'files'">
            <el-form-item label="File name">
              <el-input v-model="filter.file_name"></el-input>
            </el-form-item>
            <el-form-item label="Content type">
              <el-select v-model="filter.file_type" clearable>
                <el-option v-for="type in types" :key="type" :value="type">{{ type }}
                </el-option>
              </el-select>
            </el-form-item>
            <el-button :loading="false" class="btn btn-primary btn-lg" @click="applyFilter" icon="vik vik-search">
              Apply
            </el-button>
          </el-form>
          <div v-if="view == 'kv'">
            <h2>Spaces</h2>
            <VuePerfectScrollbar v-if="kv.spaces.length > 0" class="scroll-area card-list"
              :settings="{ wheelPropagation: false }" @ps-y-reach-end="scrollEnd">

              <router-link tag="div" v-for="(space, idx) in kv.spaces" :key="idx"
                :to="{ name: 'SingleStorageKV', params: { space: space } }" v-bind:class="{
                  active: $route.params.space == space,
                }" class="card status-bar" style="cursor: pointer">
                <div class="card-body">
                  <h5 class="card-title">{{ space }}</h5>
                </div>
              </router-link>
            </VuePerfectScrollbar>
          </div>
        </div>
      </div>

      <div class="col">
        <div class="content">
          <div class="market-page">
            <h1 v-if="view == 'tables'">Tables</h1>
            <button class="filter-btn btn-sm btn-primary" @click="filterDrawer = true">
              <i class="vik vik-adjust mr-2"></i>Filter
            </button>
          </div>
          <div class="row item-container attach-list" v-if="view == 'files'">
            <div class="col-md-6" v-for="file in files" :key="file.id">
              <article class="attach-card">
                <div class="attach-card-left-side">
                  <div class="attach-article-card-title">
                    <h3 class="d-flex align-items-center" style="cursor: pointer"
                      @click="downloadFile(file.id, file.file_name)">
                      <i class="el-icon-paperclip"></i> {{ file.file_name }}
                    </h3>

                    <span class="attach-source">ID: {{ file.id }} Type: {{ file.content_type }}</span>
                    <p class="attach-info">
                      {{ fileSize(file.size) }}, {{ timeAgo(file.date) }}
                    </p>
                  </div>
                </div>
                <div class="attach-card-right-side attach-pop">
                  <div class="attach-tags">
                    <span class="tag" v-if="file.interaction_hash" @click="goToInteraction(file.interaction_hash)">go to
                      interaction</span>
                  </div>
                  <div class="btn-group">
                    <!-- { name: "EditFile", params: { hash: "new" } } -->
                    <router-link v-if="file.content_type.match(/text\//)" :to="{
                      name: 'EditFile',
                      params: { hash: file.id },
                    }"> <span class="vik-button btn-sm btn-icon btn vik-button--default"><i
                          class="vik vik-edit"></i></span>
                    </router-link>




                    <el-dropdown trigger="click" @command="handleCommand">
                      <span class="
                                                                  vik-button
                                                                  btn-sm btn-icon btn
                                                                  vik-button--default
                                                                "><i class="el-icon-more"></i></span>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item icon="vik vik-download" :command="{
                          cmd: 'download_file',
                          file_name: file.file_name,
                          file_hash: file.id,
                        }">Download</el-dropdown-item>
                        <el-dropdown-item class="del" icon="vik vik-delete" :command="{
                          cmd: 'remove_file',
                          file_name: file.file_name,
                          file_hash: file.id,
                        }">Remove</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                </div>
              </article>
            </div>

          </div>
          <el-pagination v-if="view == 'files'" style="margin-top: 10px" background
            :current-page.sync="filesPagination.currentPage" layout="prev, pager, next, sizes"
            :total="filesPagination.total" :page-sizes="[10, 100, 1000, 10000]"
            :page-size.sync="filesPagination.pageSize" @current-change="loadFiles"
            @size-change="loadFiles"></el-pagination>

          <div class="row item-container attach-list" v-if="view == 'kv'">
            <div v-if="!$route.params.space">Space is not selected</div>
            <div class="col-md-11" v-else>
              <div class="table-responsive log-table">
                <el-table :data="kv.records" style="width: 100%">
                  <el-table-column label="Key" prop="key">
                    <!-- 
                    <template slot-scope="scope">
                      <el-tag size="medium">{{ scope.row.level }}</el-tag>
                    </template>
-->
                  </el-table-column>
                  <el-table-column label="Value" prop="value">

                  </el-table-column>
                  <el-table-column align="right">
                    <template slot="header" slot-scope="scope">
                      <el-input v-model="kv.filter" size="mini" placeholder="Type to search" @input="loadKVSpaceData" />
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination style="margin-top: 10px" background :current-page.sync="kv.currentPage"
                  layout="prev, pager, next, sizes" :total="kv.total_records" :page-sizes="[10, 100, 1000, 10000]"
                  :page-size.sync="kv.pageSize" @current-change="loadKVSpaceData"
                  @size-change="loadKVSpaceData"></el-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="Upload a file" :visible.sync="uploadDialogVisible" class="upload-create-modal">
      <div style="width: 100%; display: inline-flex">
        <div class="border-block" style="background:transparent;">
          <el-upload :headers="extraHaders" ref="upload" :on-success="onFilesUploaded" drag
            action="/api/storage/uploadFile/" :auto-upload="false" :file-list="uploadedFiles" multiple>
            <i class="vik vik-upload"></i>
            <div class="el-upload__text">
              Drop file here or <em>click to choose</em>
            </div>
            <div class="el-upload__tip" slot="tip">
              files with a size less than 256mb
            </div>
          </el-upload>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <div class="btn-line">
          <button class="btn btn-primary" @click="uploadDialogVisible = false">
            Cancel
          </button>
          <el-button :loading="false" class="btn btn-success" @click="upload()" icon="vik vik-save">
            Upload
          </el-button>
        </div>
      </span>
    </el-dialog>

    <el-drawer title="Filter" direction="rtl" :append-to-body="true" :visible.sync="filterDrawer"
      custom-class="filter-drawer">
      <div class="drawer-body">
        <div class="category-list">
          <el-form>
            <el-form-item label="File name">
              <el-input v-model="filter.file_name"></el-input>
            </el-form-item>
            <el-form-item label="Content type">
              <el-select v-model="filter.file_type" clearable>
                <el-option v-for="type in types" :key="type" :value="type">{{ type }}
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </div>

      <div class="drawer-footer mt-auto w-100">
        <el-button :loading="false" class="btn btn-primary btn-lg" @click="applyFilter" icon="vik vik-search">
          Apply
        </el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { bus } from "@/bus.js";
import * as utils from "@/utils";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import {
  getFiles,
  getKVSpaces,
  getKVSpaceData,
  getFileTypes,
  removeFile,
} from "@/api.js";
import config from "@/config";

export default {
  props: ["view"],
  components: { VuePerfectScrollbar },
  data() {
    return {
      form: {},
      newFile: { name: "", content: "" },
      uploadDialogVisible: false,
      files: [],
      applyLoading: false,
      uploadedFiles: [],
      menuItems: [],
      types: [],
      tabCreateFile: true,
      filesLoading: false,
      databasesLoading: false,
      filterDrawer: false,
      filter: { file_name: "", file_type: "" },
      filteredKVSpaces: [],
      rules: {
        name: [
          {
            required: true,
            message: "Name is required",
            trigger: "blur",
          },
        ],
        content: [
          {
            required: true,
            message: "Must not be empty",
            trigger: "blur",
          },
        ],
      },

      // files: { total: 0, files: [] },
      kv: {
        total: 0,
        spaces: [],
        records: [],
        total_records: 0,
        currentPage: 1,
        pageSize: 10,
        filter: "",
      },
      filesPagination: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      }
    };
  },
  created() {
    bus.$on("refresh-files", () => this.loadFiles());
  },
  watch: {
    $route() {
      this.loadData();
    },
  },
  mounted() {
    this.loadData();
  },
  computed: {
    extraHaders() {
      return {
        Authorization: "Bearer " + localStorage.getItem("token"),
      };
    },
  },
  methods: {
    async uploadFile() {
      let that = this;
      if (config.desktop_mode) {
        const m = await import("@/../wailsjs/go/api/APIC");
        m["UploadFile"]()
          .then((selection) => {
            console.log("selecterion then", selection);
            that.loadFiles();
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        this.uploadDialogVisible = true;
      }
    },
    async createNewFile() {
      // NewFile
      this.$router.push({ name: "EditFile", params: { hash: "new" } });
    },

    loadData() {
      if (this.$route.name == "StorageFiles") {
        this.loadFiles();
        this.loadFileTypes();
      } else if (this.$route.name == "StorageKV") {
        this.loadKVSpaces();
      } else if (this.$route.name == "SingleStorageKV") {
        this.loadKVSpaces();
        this.loadKVSpaceData();
      }
    },
    scrollEnd: function () {
      // if (this.tasks.length > 5) this.load(false);
      return false;
    },
    timeAgo(d) {
      return utils.timeAgo(d);
    },
    handleCommand(item) {
      let { cmd, file_name, file_hash } = item;
      if (cmd === "download_file") {
        this.downloadFile(file_hash, file_name);
      }
      if (cmd === "remove_file") {
        this.removeFile(file_hash);
      }
    },
    goToInteraction(hash) {
      this.$router.push({ name: "Iteractions", query: { hash: hash } });
    },
    async applyFilter() {
      this.applyLoading = true;
      await this.loadFiles();
      this.applyLoading = false;
    },
    async loadFiles() {
      this.filesLoading = true;
      let params = Object.assign(this.$route.query, { page: this.filesPagination.currentPage, pageSize: this.filesPagination.pageSize });
      params = Object.assign(params, this.filter);
      getFiles(utils.objectToString(params)).then((data) => {
        this.files = data.Records;
        this.filesPagination.total = data.Total
        this.filesLoading = false;
      });
    },
    async loadFileTypes() {
      getFileTypes().then((data) => {
        this.menuItems = [];
        this.types = data.Records;
      });
    },

    loadKVSpaces() {
      // todo: add pagination
      getKVSpaces().then((data) => {
        this.kv.spaces = data.Records;
        this.kv.total = data.Total;
      });
    },

    loadKVSpaceData() {
      let params = Object.assign(this.$route.query, { page: this.kv.currentPage, pageSize: this.kv.pageSize });
      params = Object.assign(params, { space: this.$route.params.space, filter: this.kv.filter });
      getKVSpaceData(utils.objectToString(params)).then((data) => {
        this.kv.records = data.Records;
        this.kv.total_records = data.Total;
      });
    },

    async downloadFile(id, name) {
      console.log("download file", id, name);
      let that = this;
      if (config.desktop_mode) {
        const m = await import("@/../wailsjs/go/api/APIC");
        m["DownloadFile"](id)
          .then()
          .catch((err) => {
            console.log(err);
          });
      } else {
        let anchor = document.createElement("a");
        anchor.download = name;
        anchor.href = `/api/storage/downloadFile/${id}`;
        anchor.click();
      }
    },
    removeFile(id) {
      removeFile({ id: id })
        .then(() => {
          this.loadFiles();
        })
        .catch((err) => {
          this.$notify.error({
            title: "Error",
            message: err.error,
          });
        });
    },
    onFilesUploaded() {
      this.uploadDialogVisible = false;
      this.uploadedFiles = [];
      bus.$emit("refresh-files");
    },
    upload() {
      this.$refs.upload.submit();
    },
    fileSize(size) {
      return utils.humanFileSize(size);
    },
    capitalize(s) {
      return utils.capitalize(s);
    },
    menuFilter(items, name) {
      return items.filter((i) => i.name == name);
    },
    isActiveMenuItem(k, v) {
      return this.$route.query[k] && this.$route.query[k] === v;
    },
    addParam(k, v) {
      utils.addQueryParam(this, k, v);
    },
    removeParam(k) {
      utils.removeQueryParam(this, k);
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/pages/Storage.vue